import * as Yup from "yup";
import { SubscriptionFormValues } from "./formik";
import { TFunction } from "react-i18next";

const FormSchema = (t: TFunction) => {
  const fieldSchema: { [key in keyof SubscriptionFormValues]?: any } = {
    firstName: Yup.string().required(
      t("isRequired", { fieldName: "First name" })
    ),
    lastName: Yup.string().required(
      t("isRequired", { fieldName: "Last name" })
    ),
    email: Yup.string().required(t("isRequired", { fieldName: "Email" })),
    address: Yup.string().required(t("isRequired", { fieldName: "Address" })),
    city: Yup.string().required(t("isRequired", { fieldName: "City" })),
    country: Yup.string().required(t("isRequired", { fieldName: "Country" })),
    state: Yup.string().required(t("isRequired", { fieldName: "State" })),
    zipcode: Yup.string().required(t("isRequired", { fieldName: "Zipcode" })),
  };
  return Yup.object().shape(fieldSchema);
};
export default FormSchema;
